import { useReactiveVar } from "@apollo/client";
import {
  ContentTypeEnum,
  SubscriptionPlanStatusEnum,
} from "../../../../../generated/graphql";
import { mobileAppModel } from "../../state";
import { getTextHelperTitle } from "../../utils";
import { maxDescriptionSymbols } from "../../constants";
import { Box, FormControlLabel } from "@material-ui/core";
import {
  CheckboxStyled,
  ModalWithPhotoForm,
  ModalWithPhotoInput,
} from "../../../../shared/Style/Style";
import { TextareaResize } from "../../../../shared/TextareaResize/TextareaResize";
import { SelectSubscriptionsPlan } from "../../../../MobileAppPageEdit/Selectors/SelectSubscriptionsPlan";
import { AppModelBundles } from "../AppModelBundles";
import { AppModelRates } from "../AppModelRates";
import { MediaCards } from "../MediaCards";
import { SelectExperimentType } from "../ModelSelectors/SelectExperimentType";
import { SelectSchoolGrades } from "../ModelSelectors/SelectSchoolGrades";
import { SelectSubjectCategory } from "../ModelSelectors/SelectSubjectCategory";
import { SelectEducationAreas } from "../ModelSelectors/SelectEducationAreas";
import { SelectLanguage } from "../ModelSelectors/SelectLanguage";
import { SelectTheme } from "../ModelSelectors/SelectTheme";
import { SelectTagCategory } from "../ModelSelectors/SelectTagCategory";
import { AppModelPrice } from "../AppModelPrice";
import { SelectContentTextBooks } from "../ModelSelectors/SelectContentTextBooks";
import { PlatformTabs } from "../PlatformTabs/PlatformTabs";
import AttachExperimentModelButton from "../AttachExperimentModelButton/AttachExperimentModelButton";

export const ModelForm = () => {
  const model = useReactiveVar(mobileAppModel.model);
  const inputErrors = useReactiveVar(mobileAppModel.inputErrors);
  const isLoading = useReactiveVar(mobileAppModel.updateLoading);

  if (!model) return null;

  const {
    name,
    description,
    subscriptionPlan,
    inGradeOrder,
    contentAuthor,
    libraryContent,
    contentType,
  } = model;
  const isExperimentLab = !!libraryContent?.isExperimentLab;

  const subscriptionPlanHandler = (
    subscriptionPlan: SubscriptionPlanStatusEnum | null,
  ) => {
    mobileAppModel.setSubscriptionPlan(subscriptionPlan);
  };

  return (
    <ModalWithPhotoForm style={{ marginLeft: "24px" }}>
      <ModalWithPhotoInput
        disabled={isLoading}
        required
        label="Заголовок"
        error={inputErrors.name.error}
        value={name}
        helperText={getTextHelperTitle(name)}
        onFocus={() => mobileAppModel.setInputErrors("name", false)}
        onChange={({ target: { value } }) => {
          mobileAppModel.setTitle(value);
        }}
      />

      <TextareaResize
        disabled={isLoading}
        value={description}
        error={inputErrors.description.error}
        label="Опис *"
        minRows={7}
        style={{ width: "100%" }}
        onFocus={() => mobileAppModel.setInputErrors("description", false)}
        onChange={({ target: { value } }) => {
          if (value.length >= maxDescriptionSymbols) return;
          mobileAppModel.setDescription(value);
        }}
      />

      <Box mt={2}>
        <SelectSubscriptionsPlan
          disabled={isLoading}
          status={subscriptionPlan}
          setSubscriptionAccess={subscriptionPlanHandler}
        />
      </Box>

      <AppModelPrice />

      <SelectExperimentType />

      <SelectTagCategory />

      {contentType?.name === ContentTypeEnum.ArWebgl && (
        <FormControlLabel
          disabled={isLoading}
          control={
            <CheckboxStyled
              checked={isExperimentLab}
              onClick={() =>
                mobileAppModel.setIsExperimentLab(!isExperimentLab)
              }
            />
          }
          label="Лабораторна работа"
        />
      )}

      <AttachExperimentModelButton />

      <PlatformTabs />

      <AppModelBundles />

      <MediaCards />

      <SelectLanguage />

      <SelectSubjectCategory />

      <SelectTheme />

      <SelectSchoolGrades />

      <ModalWithPhotoInput
        disabled={isLoading}
        fullWidth
        margin="normal"
        label="Порядок МОН"
        value={inGradeOrder}
        onChange={({ target: { value } }) =>
          mobileAppModel.setInGradeOrder(+value)
        }
      />

      <SelectEducationAreas />

      <SelectContentTextBooks />

      <ModalWithPhotoInput
        disabled={isLoading}
        fullWidth
        label="Автор"
        value={contentAuthor}
        style={{ marginTop: "22px" }}
        onChange={({ target: { value } }) =>
          mobileAppModel.setContentAuthor(String(value))
        }
      />

      <AppModelRates />
    </ModalWithPhotoForm>
  );
};
